import { render, staticRenderFns } from "./WidgetColumnChooser.vue?vue&type=template&id=38f20b04&scoped=true"
import script from "./WidgetColumnChooser.vue?vue&type=script&lang=js"
export * from "./WidgetColumnChooser.vue?vue&type=script&lang=js"
import style0 from "./WidgetColumnChooser.vue?vue&type=style&index=0&id=38f20b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f20b04",
  null
  
)

export default component.exports